export default __webpack_public_path__ + "static/review-71b2083f9c114597dc9c8d0052525e70.svg";